import React, { useEffect, useContext, useMemo } from 'react';

// MUI
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';

// Custom Components
// import PublicPage from '@/ui/PublicPage/PublicPage';
import LoginForm from '@/views/core/Auth/LoginForm';
import HomePageFooter from '@/views/core/HomePageFooter';
import AppPage from '@/ui/AppPage/AppPage';

import model from '@/models/user';
import DataController from '@/lib/DataController';
import Permissions from '@/lib/permissions';

import TenantContext, { TenantContextType } from '@/context/TenantContext/TenantContext';

const LoginPage = () => {
  const dc = new DataController(model);

  const tenantContext = useContext(TenantContext) as TenantContextType;

  useEffect(() => {
    if (localStorage.getItem('auth_token') !== tenantContext?.publicToken) {
      window.location.href = "/";
    }
  }, [])

  const loginLogo = useMemo(() => {
    const hasSidebarGrb = !!tenantContext?.tenantTheme?.login_logo;
    if (hasSidebarGrb) {
      return `data:${tenantContext?.tenantTheme?.login_logo_type};base64, ${tenantContext?.tenantTheme?.login_logo}`;
    }
    return undefined;
  }, [tenantContext]);

  return (
    <AppPage hideNavDrawer showBg titlett="page.login" needPermission={[Permissions.Elevate]}>
      <Box m={2}>
        <Container maxWidth="sm">
          <LoginForm dc={dc} form="login" mode="update" onClose={() => { }} />
          {loginLogo ?
            <Card sx={{mt: 4}}>
              <img
                src={loginLogo}
                style={{
                  transition: 'width 0.3s',
                  maxWidth: '100%',
                }}
                alt="Login Logo"
              />
            </Card>
            : null}

        </Container>
      </Box>
      <HomePageFooter
        isAbsoluteBottom
        isBgColored
      />
    </AppPage>
  );
};

export default LoginPage;
